import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("要查看的承保单位"),
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.unitFun
    },
    model: {
      value: _vm.form.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unitId", $$v);
      },
      expression: "form.unitId"
    }
  }, _vm._l(_vm.unitList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1), _c("a-card", {
    attrs: {
      title: _vm.$t("分支机构"),
      hoverable: false,
      bordered: true
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("输入关键字进行过滤")
    },
    model: {
      value: _vm.filterText,
      callback: function ($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }), _vm.isAuth("home.agencyStore") ? _c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    staticStyle: {
      padding: "0"
    },
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "organizationalInfo",
          params: {
            unit: _vm.form.unitId,
            agency: _vm.form.agencyId || -1,
            id: -1,
            level: _vm.level
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增分支机构")))])], 1) : _vm._e(), _c("el-tree", {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      data: _vm.data,
      props: _vm.defaultProps,
      "default-expand-all": "",
      "filter-node-method": _vm.filterNode,
      "expand-on-click-node": false,
      "highlight-current": true,
      "node-key": "id"
    },
    on: {
      "node-click": _vm.handleNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        node
      }) {
        return _c("span", {
          staticClass: "custom-tree-node"
        }, [_c("a-tooltip", {
          staticClass: "label",
          attrs: {
            placement: "top",
            title: node.label
          }
        }, [_vm._v(" " + _vm._s(node.label) + " ")])], 1);
      }
    }])
  })], 1)], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("机构列表"),
      hoverable: false,
      bordered: true
    }
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("机构全称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("机构级别"),
      allowClear: ""
    },
    model: {
      value: _vm.form.level,
      callback: function ($$v) {
        _vm.$set(_vm.form, "level", $$v);
      },
      expression: "form.level"
    }
  }, _vm._l(_vm.agencyLevelList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("机构状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("已禁用")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("已启用")))])], 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSeachFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1)], 1), _c("standard-table", {
    staticClass: "marginT20",
    attrs: {
      tableData: _vm.tableData,
      tableHead: _vm.tableHead,
      loading: _vm.loading,
      bordered: "",
      pagination: _vm.pagination
    },
    on: {
      changeCurrent: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function ({
        index
      }) {
        return _c("div", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "status",
      fn: function ({
        text,
        record
      }) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "level",
      fn: function ({
        text
      }) {
        return [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("总公司") : text == 2 ? _vm.$t("分公司") : text == 3 ? _vm.$t("中心支公司") : text == 4 ? _vm.$t("支公司") : text == 5 ? _vm.$t("营业部或营销服务部") : text == 6 ? _vm.$t("业务一部") : _vm.$t("业务二部")) + " ")];
      }
    }, {
      key: "action",
      fn: function ({
        record
      }) {
        return _c("div", {}, [_vm.isAuth("home.agencyEdit") ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "organizationalInfo",
                params: {
                  unit: _vm.form.unitId,
                  id: record.id,
                  agency: _vm.form.agencyId || -1,
                  level: record.level
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()], 1);
      }
    }])
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };